
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SettingsTitleBar from '@components/settings/SettingsTitleBar.vue';
import ColorPicker from '@components/settings/ColorPicker.vue';
import SettingsFooter from '@components/settings/SettingsFooter.vue';
import AppPage from '@components/new-styleguide/AppPage.vue';
import AppContent from '@components/new-styleguide/AppContent.vue';
import { PilotMutation } from '@/generated-clients/myTrips';
import IconColors from '@/config/IconColors';
import AppEditableHeader from '@components/new-styleguide/AppEditableHeader.vue';
import goBackWithFallback from '@util/goBackWithFallback';
import { RouterFrom } from '@/router/Routes';
import { Location } from 'vue-router';

const SettingsModule = namespace('Settings');
const RouterModule = namespace('Router');

@Component({
  name: 'PilotAdd',
  components: {
    AppPage,
    AppContent,
    AppEditableHeader,
    SettingsTitleBar,
    ColorPicker,
    SettingsFooter
  }
})
export default class PilotAdd extends Vue {
  @SettingsModule.Action('createPilot')
  private createPilot;

  @RouterModule.State('from')
  private from: RouterFrom;

  private pilot: PilotMutation = {
    firstname: '',
    lastname: '',
    nickname: '',
    initial: '',
    color: ''
  }

  private disabled = false;
  private errorMessage = '';

  created() {
    this.pilot.color = this.colors[0];
  }

  get backButton() {
    return { text: this.getCallbackTripId ? 'Zurück zur Fahrt' : 'Zurück zu Personen', location: this.backLocation };
  }

  get colors() {
    return IconColors.codes;
  }

  get nameError() {
    return this.pilot.firstname.length === 0 && this.pilot.nickname.length === 0;
  }

  get initialError() {
    return this.pilot.initial.length !== 1;
  }

  get errorsExist() {
    return this.nameError || this.initialError;
  }

  get getCallbackTripId() {
    return this.$route.query.tripId;
  }

  private nameChange(name) {
    this.pilot.nickname = name
    if (this.pilot.nickname.length >= 1) {
      this.pilot.initial = this.pilot.nickname[0].trim().toUpperCase();
    }
  }

  get backLocation(): Location {
    if (this.getCallbackTripId) {
      return { name: 'myTripsEdit', params: { id: String(this.getCallbackTripId) } };
    } else {
      return { name: 'pilotsOverview' };
    }
  }

  private async submit() {
    if (!this.errorsExist) {
      this.disabled = true;

      try {
        const p = await this.createPilot({ pilot: this.pilot });
        if (this.getCallbackTripId) {
          const backLoc = this.backLocation;
          backLoc.query = { pilotId: p.id }
          goBackWithFallback(this.$router, !!this.from.name, backLoc, false, true);
        } else {
          goBackWithFallback(this.$router, !!this.from.name, this.backLocation);
        }
      } catch (error) {
        this.errorMessage = 'Fehler beim Speichern der Person. Bitte versuchen sie es später erneut.'
      } finally {
        this.disabled = false;
      }
    }
  }
}
